import { THEME } from "@excalidraw/excalidraw";

import type { Theme } from "@excalidraw/element/types";

import { STORAGE_KEYS } from "./app_constants";

/**
 * MiBoard currently offers a single, predictable visual mode. Keeping this
 * here (instead of relying on the operating-system preference) also prevents
 * a previously saved Excalidraw dark-theme preference from changing the UI.
 */
export const useHandleAppTheme = () => {
  const setAppTheme = (_theme: Theme | "system") => {
    localStorage.setItem(STORAGE_KEYS.LOCAL_STORAGE_THEME, THEME.LIGHT);
  };

  return {
    editorTheme: THEME.LIGHT,
    appTheme: THEME.LIGHT,
    setAppTheme,
  };
};
